import React from 'react';
import Scheduling from '../../components/Scheduling';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function SchedulingPage() {
  return (
    <AppLayout title="Agendamento" subtitle="Planejamento de publicações" fullWidth>
      <Scheduling />
    </AppLayout>
  );
}

export default SchedulingPage;
